import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import './setupAxios';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import "@popperjs/core";
import "bootstrap";

// Define process globally for browser use
if (typeof window.process === "undefined") {
  window.process = {};
}

if (typeof process !== "undefined") {
  process.browser = true;
}

window.process.env = { NODE_ENV: "development" };
window.process.browser = true;

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <HashRouter>
    <App />
  </HashRouter>
);
